<template>
  <v-row>
    <v-col cols="12" md="4">
      <v-autocomplete
          :label="$t('vehicle.brand')"
          :placeholder="$t('vehicle.select-brand')"
          :items="brands"
          item-text="name"
          item-value="name"
          v-model="selectedBrand"
          outlined
          clearable
          hide-details="auto"
          :rules="rules"
          @change="onBrandChange"
      />
    </v-col>
    <v-col cols="12" md="4">
      <v-autocomplete
          :label="$t('vehicle.model')"
          :placeholder="$t('vehicle.select-model')"
          :items="models"
          item-text="name"
          item-value="name"
          v-model="selectedModel"
          outlined
          clearable
          hide-details="auto"
          :rules="rules"
          :disabled="!selectedBrand"
          @change="onModelChange"
      />
    </v-col>
    <v-col cols="12" md="4">
      <v-autocomplete
          :label="$t('vehicle.version')"
          :placeholder="$t('vehicle.select-version')"
          :items="versions"
          :item-text="versionLabel"
          item-value="id"
          v-model="internalValue"
          outlined
          clearable
          hide-details="auto"
          :disabled="!selectedModel"
          :rules="rules"
      />
    </v-col>
  </v-row>
</template>

<script>
import VehicleRepository from "@repository/VehicleRepository";

export default {
  props: {
    value: String,
    initialVersion: Object,
    rules: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      brands: [],
      models: [],
      versions: [],
      selectedBrand: null,
      selectedModel: null,
    }
  },

  computed: {
    internalValue: {
      get() { return this.value },
      set(val) { this.$emit('input', val) },
    },
  },

  mounted() {
    this.loadBrands()
    if (this.initialVersion) {
      this.initFromVersion(this.initialVersion)
    }
  },

  watch: {
    initialVersion(val) {
      if (val) {
        this.initFromVersion(val)
      }
    },
  },

  methods: {
    initFromVersion(version) {
      this.selectedBrand = version.brand
      if (version.brand) {
        VehicleRepository.models(version.brand).then(data => {
          this.models = data
          this.selectedModel = version.model
          if (version.model) {
            VehicleRepository.versions(version.brand, version.model).then(data => {
              this.versions = data
            })
          }
        })
      }
    },

    loadBrands() {
      VehicleRepository.brands().then(data => {
        this.brands = data
      }).catch(err => {
        this.notifyError(err)
      })
    },

    onBrandChange(brand) {
      this.selectedModel = null
      this.internalValue = null
      this.models = []
      this.versions = []
      if (brand) {
        VehicleRepository.models(brand).then(data => {
          this.models = data
        }).catch(err => {
          this.notifyError(err)
        })
      }
    },

    onModelChange(model) {
      this.internalValue = null
      this.versions = []
      if (model && this.selectedBrand) {
        VehicleRepository.versions(this.selectedBrand, model).then(data => {
          this.versions = data
        }).catch(err => {
          this.notifyError(err)
        })
      }
    },

    versionLabel(item) {
      let label = item.version || item.name || item.id
      if (item.availabilityDateFrom) {
        label += ' (' + item.availabilityDateFrom.substring(0, 4) + ')'
      }
      return label
    },

    reset() {
      this.selectedBrand = null
      this.selectedModel = null
      this.models = []
      this.versions = []
      this.internalValue = null
    },
  },
}
</script>
